import { Money } from './core.models';
import { FreeRequestParams } from './shared.models';

export type OrganizationListParams = FreeRequestParams & {};

export type PaymentAggregator = 'Greenpay' | 'GREENPAY' | 'PACIFIK_TECH';

export enum PaymentOperator {
  ORANGE = 'ORANGE',
  MTN = 'MTN',
  MOOV = 'MOOV'
}

export enum PaymentMethod {
  ORANGE_MONEY = 'orange_money',
  MOOV_MONEY = 'moov_money',
  MTN_MONEY = 'mtn_money',
  MOBILE_MONEY = 'mobile_money',
  CREDIT_CARD = 'credit_card',
  WAVE_MONEY = 'wave_money',
  TPE = 'tpe',
  VISA = 'visa',
  MASTERCARD = 'mastercard'
}

export type Invoice = {
  firstName: string;
  lastName: string;
  city: string;
  country: string;
  district: string;
  addressLine: string;
};

export enum PaymentSource {
  FNE = 'fne',
  MOBILE = 'mobile',
  TERNE = 'terne'
}

export type PaymentCheckoutParams = {
  paymentMethod: PaymentMethod;
  phoneNumber: string;
  amount: Money;
  invoice: Invoice;
};

export type Payment = {
  id: string;
  paymentMethod: PaymentMethod;
  phoneNumber: string | null;
  issuedAt: string;
  processedAt: string | null;
  amount: Money;
  totalAmount: Money;
  result: Result;
  fee: Money;
  invoice: Invoice;
  organizationId: string;
  referenceTransaction: string | null;
  triggerType: TriggerType;
  source: PaymentSource;
  createdAt: string;
  updatedAt: string;
};

export type PaymentListParams = FreeRequestParams;

export enum TriggerType {
  manual = 'manual',
  automatic = 'automatic'
}

export type TransactionResultStatus =
  | 'pending'
  | 'failed'
  | 'completed'
  | 'refused'
  | 'processing'
  | 'reversed'
  | 'canceled'
  | 'accepted'
  | 'unknown'
  | 'expired';

export interface Result {
  status: TransactionResultStatus;
  statusReason?: string;
}

export type PaymentCheckout = {
  paymentLink: string;
  payment: Payment;
};

export type PaymentCreationParams = {
  paymentMethod: PaymentMethod;
  phoneNumber: string;
  amount: Money;
  invoice?: Invoice;
  triggerType?: TriggerType;
  redirectUrl: string;
};

export type PaymentVerification = {
  paymentId: string;
  status: TransactionResultStatus;
  statusReason?: string;
  referenceTransaction: string;
};

export type PaymentCallbackParams = {
  ExternalID: string;
  TransactionStatus: 'SUCCESSFUL' | 'FAILED' | 'TIMEOUT';
  TransactionID: string;
  DateResponse: string;
  ErrorReason: string | null;
};
